import { PayloadAction } from '@reduxjs/toolkit';
import { ErrorNotifyData } from './types';

export const reducers = {
  openErrorNotification(state, action: PayloadAction<ErrorNotifyData>) {
    state.data = action.payload;
  },
};
